/* unplugin-vue-components disabled */import { render } from "./introduction.vue?vue&type=template&id=2a1a9690&scoped=true"
import script from "./introduction.vue?vue&type=script&lang=js"
export * from "./introduction.vue?vue&type=script&lang=js"

import "./introduction.vue?vue&type=style&index=0&id=2a1a9690&scoped=true&lang=css"

import exportComponent from "D:\\WorkPlace\\官网\\html-bcepd-project-website-digital-read\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1a9690"]])

export default __exports__